import { logInfo } from '../config_and_helpers/logger';

const LOG_CONTEXT = 'ProductLogDelete';

/**
 * Client-only log ids are `Date.now()` (~1.7e12). Postgres PKs stay far below 1e12.
 * `new Date(smallInteger)` is a valid Date, so a Date-parse check cannot tell them apart.
 */
export const TEMPORARY_CLIENT_LOG_ID_THRESHOLD_MS = 1e12;

/**
 * Whether `log.id` was generated in the browser before the log was refetched from the API.
 *
 * @param {number|string|null|undefined} logId
 * @returns {boolean}
 */
export function isTemporaryClientLogId(logId) {
  if (logId == null || logId === '') {
    return false;
  }
  const numericId = Number(logId);
  return Number.isFinite(numericId) && numericId >= TEMPORARY_CLIENT_LOG_ID_THRESHOLD_MS;
}

/**
 * Query params for `DELETE products/delete_product_log/`.
 * Prefer `log_id` for persisted logs; `stock_item_id` only for unsynced client rows.
 *
 * @param {Object|null|undefined} log
 * @returns {{ params: { log_id?: number|string, stock_item_id?: number|string } }|{ error: string }}
 */
export function resolveProductLogDeleteQuery(log) {
  if (!log) {
    return { error: 'missing_log' };
  }
  if (log.id != null && log.id !== '' && !isTemporaryClientLogId(log.id)) {
    logInfo(LOG_CONTEXT, 'delete query uses log_id', { logId: log.id });
    return { params: { log_id: log.id } };
  }
  if (log.stock_item_id != null && log.stock_item_id !== '') {
    logInfo(LOG_CONTEXT, 'delete query uses stock_item_id', {
      stockItemId: log.stock_item_id,
      temporaryLogId: log.id ?? null,
    });
    return { params: { stock_item_id: log.stock_item_id } };
  }
  return { error: 'missing_id' };
}
